<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="internships-administrators"
            :items="tableData"
            :fields="internshipFields"
            :show-empty="true">
            <template #cell(owner)="data">
                <div class="internship-owner">
                    {{ data.item.owner }}
                </div>
            </template>

            <template v-slot:cell(action)="data">
                <div class="management">
                    <b-button
                        class="btn-eye btn-edit-internship btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.open')"
                        @click="openInternship(data.item.internship)">
                    </b-button>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('internship.no_internships_found') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-internship-modal-component
            :internship-tags-in="internshipTagsIn"
            ref="internship-modal"
            :google-map-api="googleMapApi">
        </design-2021-internship-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-index-all-tab-component',
    props: ['internshipsIn', 'internshipTagsIn', 'googleMapApi'],
    data() {
        return {
            internshipFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                // {
                //     key: 'enrolledStudents',
                //     label: 'Ingeschreven'
                // },
                // {
                //     key: 'applyingStudents',
                //     label: 'Aanmeldingen'
                // },
                {
                    key: 'tags',
                    label: this.$t('internship.internship_type'),
                },
                {
                    key: 'owner',
                    label: this.$t('common.organization'),
                },
                {
                    key: 'location',
                    label: this.$t('common.city'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.internshipsIn.map((internship) => {
                return {
                    id: internship.id,
                    internship: internship,
                    name: internship.name,
                    location: internship.location,
                    owner: internship.organization,
                    tags: internship.internship_tags.map((tag) => tag.name).join(', '),
                };
            });
        },
    },
    methods: {
        openInternship(internship) {
            this.$refs['internship-modal'].show(internship);
        },
    },
};
</script>

<style scoped lang="scss">
.internship-owner {
    i {
        font-size: $base-font-size;
        line-height: 1.5;
        color: $primary;
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .internships-administrators ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                flex: 1 1 auto;
                margin-bottom: 0;
            }

            .options {
                margin-left: auto;
                justify-content: flex-end;
                flex: 1 1 auto;
            }
        }
    }
}
</style>
